/*
 * @Author: your name
 * @Date: 2020-06-24 15:00:44
 * @LastEditTime: 2020-07-30 09:54:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\router\constant.js
 */
// import Index from '@/views/device'

const constant = [{
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue')
},
{
    path: '/',
    name: 'index',
    component: () => import('@/views/index.vue')
}, {
    path: '/myhome',
    name: 'MyHome',
    component: () => import('@/views/myhome/index.vue')
}, {
    path: '/404',
    name: 'Page404',
    component: () => import('@/views/404.vue')
}]

export default constant
